<template><van-form ref="FindPwdForm" :model="FindPwdForm" id="findpwd-form" @submit="onSubmit('FindPwdForm')">
  <van-field v-model="FindPwdForm.orderno" clearable label="商户单号" placeholder="请输入YN开头的商户单号" :rules="[{ required: true, pattern: /^YN\d{18}$/, message: '请输入正确的商户单号号' }]" />
  <van-field v-model="FindPwdForm.captcha" center clearable label="验证码" placeholder="请输入右侧验证码" :rules="[{ required: true, message: '验证码不能为空' }]">
    <template #button>
      <img :src="captchaUrl" @click="changeCaptcha" height="28" width="100" style="margin-left: 10px; display: block;" />
    </template>
  </van-field>
  <van-button round block type="primary" native-type="submit" :disabled="isDisable" style="margin-top: 15px;">
    下一步
  </van-button>
  <van-button round block type="info" native-type="button" :to="{ name: 'FindpwdSelectMethod' }" style="margin-top: 15px;">
    重新选择找回方式
  </van-button>
  <div style="text-align: center; margin-top: 15px;">
    <router-link :to="{ name: 'Register' }" style="color: #323233;"> 立即注册 </router-link>
    |
    <router-link :to="{ name: 'Login' }" style="color: #323233;"> 立即登录 </router-link>
  </div>
</van-form></template>
<script>
  export default {
    name: 'FindpwdByOrder',
    data() {
      return {
        FindPwdForm: {
          orderno: '',
          captcha: ''
        },
        isDisable: false,
        captchaUrl: this.$api.global.getCaptchaUrl()
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.changeStep()
      })
    },
    methods: {
      changeStep() {
        this.$root.$emit('changeCurrentStep', 1)
      },
      changeCaptcha() {
        this.captchaUrl = this.$api.global.getCaptchaUrl()
      },
      onSubmit(formName) {
        this.isDisable = true
        this.$api.user.findpwdByOrder(this.FindPwdForm)
          .then((res) => {
            if (res.data.code === 200) {
              this.$router.push({ name: 'ConfirmUsername', query: { uid: res.data.data.uid, username: res.data.data.username, orderno: this.FindPwdForm.orderno } })
            } else {
              this.$notify(res.data.message)
              this.isDisable = false
            }
          })
          .catch(() => {
            this.isDisable = false
          })
      }
    }
  }
</script>
